/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type vocabularyListItem_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type vocabularyList_viewer$ref: FragmentReference;
export type vocabularyList_viewer = {|
  +vocabulary: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +$fragmentRefs: vocabularyListItem_item$ref
      |}
    |}>
  |},
  +$refType: vocabularyList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "vocabularyList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "vocabulary",
      "storageKey": null,
      "args": null,
      "concreteType": "VocabularyConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "VocabularyEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Vocabulary",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "vocabularyListItem_item",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '0b1a4b3fba1afc5f1df938b8c321ae86';
module.exports = node;



// WEBPACK FOOTER //
// src/components/vocabulary/__generated__/vocabularyList_viewer.graphql.js